import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { emailServicePreviewFormEpic } from './previewFormEpic';
import { emailServiceSubmitFormEpic } from './submitFormEpic';

export const emailServiceEpic = () =>
  withAppCrashIfException(
    'emailService',
    combineEpics(
      withAppCrashIfException('emailServiceSubmitFormEpic', emailServiceSubmitFormEpic()),
      withAppCrashIfException('emailServicePreviewFormEpic', emailServicePreviewFormEpic()),
    ),
  );
